import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "sm:flex sm:items-start" }
const _hoisted_6 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full" }
const _hoisted_7 = { class: "mb-6 p-4 border border-gray-200 rounded-md bg-gray-50" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_9 = { class: "md:col-span-2" }
const _hoisted_10 = { class: "md:col-span-2" }
const _hoisted_11 = { class: "mt-3 flex justify-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "overflow-x-auto" }
const _hoisted_17 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_18 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }
const _hoisted_20 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_28 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_29 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" }
const _hoisted_30 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_31 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_32 = { class: "md:col-span-2" }
const _hoisted_33 = { class: "md:col-span-2" }
const _hoisted_34 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }
const _hoisted_35 = {
  key: 1,
  class: "fixed inset-0 z-60 overflow-y-auto"
}
const _hoisted_36 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_37 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" }
const _hoisted_38 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }
const _hoisted_39 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[18] || (_cache[18] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[37] || (_cache[37] = _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900 mb-4" }, " Manage Template Variables ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "font-medium mb-3" }, "Add New Variable", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Variable Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newVariable.name) = $event)),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                          placeholder: "e.g., customerName"
                        }, null, 512), [
                          [_vModelText, _ctx.newVariable.name]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Category", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newVariable.category) = $event)),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                          placeholder: "e.g., Customer"
                        }, null, 512), [
                          [_vModelText, _ctx.newVariable.category]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Description", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newVariable.description) = $event)),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                          placeholder: "e.g., Customer's full name"
                        }, null, 512), [
                          [_vModelText, _ctx.newVariable.description]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Example Value", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newVariable.exampleValue) = $event)),
                          class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                          placeholder: "e.g., John Doe"
                        }, null, 512), [
                          [_vModelText, _ctx.newVariable.exampleValue]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addVariable && _ctx.addVariable(...args))),
                        class: "px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary",
                        disabled: !_ctx.isValidNewVariable
                      }, " Add Variable ", 8, _hoisted_12)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "font-medium mb-2" }, "Available Variables", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Filter by Category", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCategory) = $event)),
                        class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "All Categories", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueCategories, (category) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: category,
                            value: category
                          }, _toDisplayString(category), 9, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.selectedCategory]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("table", _hoisted_17, [
                        _cache[27] || (_cache[27] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }, " Name "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }, " Category "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }, " Description "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }, " Example "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                            }, " Actions ")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredVariables, (variable, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_19, _toDisplayString(variable.name), 1),
                              _createElementVNode("td", _hoisted_20, _toDisplayString(variable.category), 1),
                              _createElementVNode("td", _hoisted_21, _toDisplayString(variable.description), 1),
                              _createElementVNode("td", _hoisted_22, _toDisplayString(variable.exampleValue), 1),
                              _createElementVNode("td", _hoisted_23, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.editVariable(index)),
                                  class: "text-indigo-600 hover:text-indigo-900 mr-2"
                                }, " Edit ", 8, _hoisted_24),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.confirmDelete(index)),
                                  class: "text-red-600 hover:text-red-900",
                                  disabled: variable.isSystem
                                }, " Delete ", 8, _hoisted_25)
                              ])
                            ]))
                          }), 128)),
                          (_ctx.filteredVariables.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _cache[26] || (_cache[26] = [
                                _createElementVNode("td", {
                                  colspan: "5",
                                  class: "px-6 py-4 text-center text-sm text-gray-500"
                                }, " No variables found ", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.editingVariable !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", {
                            class: "fixed inset-0 transition-opacity",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                          }, _cache[29] || (_cache[29] = [
                            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
                          ])),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "text-lg font-medium mb-4" }, "Edit Variable", -1)),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", null, [
                                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Variable Name", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editedVariable.name) = $event)),
                                    class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                                  }, null, 512), [
                                    [_vModelText, _ctx.editedVariable.name]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Category", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editedVariable.category) = $event)),
                                    class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                                  }, null, 512), [
                                    [_vModelText, _ctx.editedVariable.category]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Description", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editedVariable.description) = $event)),
                                    class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                                  }, null, 512), [
                                    [_vModelText, _ctx.editedVariable.description]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Example Value", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editedVariable.exampleValue) = $event)),
                                    class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                                  }, null, 512), [
                                    [_vModelText, _ctx.editedVariable.exampleValue]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("button", {
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args))),
                                class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm"
                              }, " Save "),
                              _createElementVNode("button", {
                                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                                class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                              }, " Cancel ")
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.deletingVariableIndex !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", {
                            class: "fixed inset-0 transition-opacity",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args)))
                          }, _cache[35] || (_cache[35] = [
                            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
                          ])),
                          _createElementVNode("div", _hoisted_37, [
                            _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4\"><div class=\"sm:flex sm:items-start\"><div class=\"mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10\"><svg class=\"h-6 w-6 text-red-600\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z\"></path></svg></div><div class=\"mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left\"><h3 class=\"text-lg leading-6 font-medium text-gray-900\"> Delete Variable </h3><div class=\"mt-2\"><p class=\"text-sm text-gray-500\"> Are you sure you want to delete this variable? This action cannot be undone. </p></div></div></div></div>", 1)),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", {
                                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.deleteVariable && _ctx.deleteVariable(...args))),
                                class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                              }, " Delete "),
                              _createElementVNode("button", {
                                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                                class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                              }, " Cancel ")
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-3 sm:w-auto sm:text-sm"
              }, " Close ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}